/**
 * Line-art coloring page for "Pumpkin, Pumpkin, You're the One!".
 * 8.5×11 aspect, thick black outlines on white.
 * Scene: a happy jack-o'-pumpkin with stem, curly vine, big leaves, and
 * autumn leaves swirling around it.
 */
export default function ColoringArtPumpkin() {
  const stroke = "#111111";
  return (
    <svg
      viewBox="0 0 816 1056"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: "100%", height: "auto", background: "#FFFFFF" }}
      role="img"
      aria-label="Coloring page: a happy pumpkin"
    >
      <g fill="none" stroke={stroke} strokeWidth="2">
        <text x="408" y="110" textAnchor="middle" fontFamily="'Fredoka', sans-serif" fontSize="46" fill={stroke} stroke="none" fontWeight="700">
          Pumpkin, Pumpkin, You're the One!
        </text>
        <text x="408" y="150" textAnchor="middle" fontFamily="'Caveat', cursive" fontSize="30" fill={stroke} stroke="none">
          — a coloring page by M.K. Bunch
        </text>
      </g>

      <g fill="none" stroke={stroke} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
        {/* Curly vine */}
        <path d="M 460 230 Q 520 200 560 240 Q 590 280 550 300 Q 520 310 510 290" />
        <path d="M 260 240 Q 220 210 180 240 Q 150 275 190 290" />

        {/* Big leaf left */}
        <path d="M 200 300 Q 130 260 90 320 Q 100 400 200 360 Q 240 340 200 300 Z" />
        <path d="M 110 320 Q 160 340 200 350" />

        {/* Big leaf right */}
        <path d="M 620 320 Q 700 280 730 340 Q 720 420 610 380 Q 570 355 620 320 Z" />
        <path d="M 720 340 Q 660 360 610 370" />

        {/* Stem */}
        <path d="M 380 320 Q 370 280 400 260 Q 435 260 440 300 Q 445 335 420 350 Z" />
        <path d="M 400 275 Q 410 300 405 340" />

        {/* Pumpkin body — 5 lobes */}
        <ellipse cx="250" cy="600" rx="130" ry="200" />
        <ellipse cx="566" cy="600" rx="130" ry="200" />
        <ellipse cx="330" cy="600" rx="140" ry="215" />
        <ellipse cx="486" cy="600" rx="140" ry="215" />
        <ellipse cx="408" cy="600" rx="160" ry="230" />

        {/* Jack-o'-lantern face */}
        {/* Left triangle eye */}
        <path d="M 340 555 L 380 555 L 360 590 Z" />
        {/* Right triangle eye */}
        <path d="M 436 555 L 476 555 L 456 590 Z" />
        {/* Little triangle nose */}
        <path d="M 400 620 L 416 620 L 408 640 Z" />
        {/* Smiley toothy mouth */}
        <path d="M 330 680 Q 408 760 486 680 L 470 690 L 465 675 L 445 692 L 440 675 L 420 695 L 415 675 L 395 695 L 390 675 L 370 692 L 365 675 L 345 690 Z" />

        {/* Ground swirl */}
        <path d="M 60 900 Q 408 850 756 900" />

        {/* Falling leaves */}
        <g>
          <path d="M 130 470 Q 100 460 100 490 Q 130 500 130 470 Z" />
          <path d="M 690 500 Q 720 490 720 520 Q 690 530 690 500 Z" />
          <path d="M 80 720 Q 50 710 50 740 Q 80 750 80 720 Z" />
          <path d="M 740 720 Q 770 710 770 740 Q 740 750 740 720 Z" />
          <path d="M 250 950 Q 220 940 220 970 Q 250 980 250 950 Z" />
          <path d="M 566 950 Q 596 940 596 970 Q 566 980 566 950 Z" />
        </g>

        {/* Tiny stars */}
        <circle cx="120" cy="200" r="4" />
        <circle cx="720" cy="200" r="4" />
        <circle cx="60" cy="580" r="3" />
        <circle cx="760" cy="600" r="3" />
      </g>

      <text x="408" y="1010" textAnchor="middle" fontFamily="'Caveat', cursive" fontSize="32" fill={stroke}>
        You're one of a kind — color like it! ✿
      </text>
    </svg>
  );
}
